import React from 'react'

const Checkmark = ({className}) => <svg
	{...className}
	width="21"
	height="22"
	viewBox="0 0 21 22"
	xmlns="http://www.w3.org/2000/svg">
	<path
		d="M0 11.2805C0 5.49911 4.70128 0.812256 10.5 0.812256C16.2992 0.812256 21 5.49911 21 11.2805C21 17.0618 16.2994 21.7487 10.5 21.7487C4.70128 21.7487 0 17.0618 0 11.2805ZM3.9505 12.0486L8.57387 16.6578L17.0495 8.20761L15.5085 6.67129L8.57387 13.5851L5.49149 10.5123L3.9505 12.0486Z"/>
</svg>

export default Checkmark
